"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebContractPaypalWebhookResponseSchema = exports.WebContractPaypalCaptureOrderResponseSchema = exports.WebContractCreatePaypalResponseSchema = exports.WebContractPaypalWebhookRequestSchema = exports.WebContractCreatePaypalRequestSchema = void 0;
const zod_1 = require("zod");
exports.WebContractCreatePaypalRequestSchema = zod_1.z.object({ orderId: zod_1.z.string() });
exports.WebContractPaypalWebhookRequestSchema = zod_1.z.object({
    event_type: zod_1.z.string(),
    resource: zod_1.z.object({ id: zod_1.z.string() }),
});
exports.WebContractCreatePaypalResponseSchema = zod_1.z.object({
    paypal: zod_1.z.object({
        id: zod_1.z.string(),
        status: zod_1.z.string(),
        approveUrl: zod_1.z.string(),
    }),
});
exports.WebContractPaypalCaptureOrderResponseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    status: zod_1.z.string(),
});
exports.WebContractPaypalWebhookResponseSchema = zod_1.z.object({ message: zod_1.z.string() });
